import $ from 'jquery';
import { getStorage } from '../../../home24/helpers/storage-factory';
import { register } from '../../core/bootstrapper';

register('cms', function() {
  /* See REBOOT-10236 */
  $('#contactForm').on('submit', function() {
    var sSubject = $('#raw_fttc_subject').val();

    if (sSubject) {
      getStorage().set('GtmContactRequest', sSubject);
    }
  });
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/cms/cmsBootstrap.js
 **/